import {Component, OnInit, Input, ChangeDetectorRef} from '@angular/core';
import { MibemCommandInputModel, TYPES_MODIFICATIONS, Model_MibemCommandGridInput, ORDER_FAMILLES_IDS, FAMILLE_CDF_VIN_ROUGE_ID, FAMILLE_CDF_SANGRIA_ROUGE_ID, Enum_TypeRemise } from '../mibem-command-input.model';
import { MibemCommandInputService } from '../mibem-command-input.service';

@Component({
    selector: 'abw-mibem-command-input-result',
    templateUrl: './mibem-command-input-result.component.html',
    styleUrls: ['./mibem-command-input-result.component.scss']
})
export class MibemCommandInputResultComponent implements OnInit {
	@Input() model: MibemCommandInputModel;
    @Input() value: Model_MibemCommandGridInput;
    bonCommande: any;
    typesModification: any[] = [];
    onlyFilledRowsFilterOn = true;
    filteredRows: any[] = [];

    constructor(
        private _mibemCommandInputService: MibemCommandInputService,
        private _cdf: ChangeDetectorRef
    ) {
        this.typesModification = TYPES_MODIFICATIONS
                                    .map(typeModif => typeModif.MOTIFS_MODIFICATION)
                                    .reduce((pre, cur) => pre.concat(cur))
                                    .map((iterator) => { var res = {}; Object.keys(iterator).forEach((k) => { res[k] = iterator[k]; }); return res; });
    }

    ngOnInit() {
        this.doGetBonCommande();
    }

    private async doGetBonCommande() {
        if (!this.value || !this.value.BON_COMMANDE_ID) { return; }
        
        try {
            const bonCommande = await this._mibemCommandInputService.doGetBonCommandeAction(this.value.BON_COMMANDE_ID.toString());
            this._formatBonCommande(bonCommande);
            this.applyFilterRows(this.onlyFilledRowsFilterOn);
            this._cdf.detectChanges();
        } catch(e) {
            throw e;
        }
    }

    isRowIncorrect(row: { QUANTITE_COMMANDE: number, GRATUITE_COMMANDE: number, QUANTITE_CHARGEMENT: number, QUANTITE_GRATUIT: number }) {
      if (!!row) {
        const qteCommande = row.QUANTITE_COMMANDE != null ? row.QUANTITE_COMMANDE : 0;
        const gratuiteCommande = row.GRATUITE_COMMANDE != null ? row.GRATUITE_COMMANDE : 0;
        const qteChargement = row.QUANTITE_CHARGEMENT != null ? row.QUANTITE_CHARGEMENT : 0;
        const qteGratuit = row.QUANTITE_GRATUIT != null ? row.QUANTITE_GRATUIT : 0;

        return qteCommande != qteChargement || gratuiteCommande != qteGratuit;
      }
      return false;
    }

    applyFilterRows(filtered: boolean) {
      this.onlyFilledRowsFilterOn = filtered;
      let filteredFamilles = JSON.parse(JSON.stringify(this.bonCommande.FAMILLES));
      if (this.onlyFilledRowsFilterOn) {
        filteredFamilles = filteredFamilles.filter(famille => {
            const touchedFamilles = Object.keys(this.value.GRID_DATAS[famille.REF_FAMILLE]).filter(k => (!!this.value.GRID_DATAS[famille.REF_FAMILLE][k].QUANTITE_COMMANDE && this.value.GRID_DATAS[famille.REF_FAMILLE][k].QUANTITE_COMMANDE != 0) || (!!this.value.GRID_DATAS[famille.REF_FAMILLE][k].GRATUITE_COMMANDE && this.value.GRID_DATAS[famille.REF_FAMILLE][k].GRATUITE_COMMANDE != 0) || (!!this.value.GRID_DATAS[famille.REF_FAMILLE][k].QUANTITE_CHARGEMENT && this.value.GRID_DATAS[famille.REF_FAMILLE][k].QUANTITE_CHARGEMENT != 0) || (!!this.value.GRID_DATAS[famille.REF_FAMILLE][k].QUANTITE_GRATUIT && this.value.GRID_DATAS[famille.REF_FAMILLE][k].QUANTITE_GRATUIT));
            return touchedFamilles.length > 0;
        });

        filteredFamilles.forEach(fFamille => {
            fFamille.ARTICLES = fFamille.ARTICLES.filter(article => {
                const touchedArticles = [];
                Object.keys(this.value.GRID_DATAS[fFamille.REF_FAMILLE]).map(k => {
                    if ((!!this.value.GRID_DATAS[fFamille.REF_FAMILLE][k].QUANTITE_COMMANDE && this.value.GRID_DATAS[fFamille.REF_FAMILLE][k].QUANTITE_COMMANDE != 0) || (!!this.value.GRID_DATAS[fFamille.REF_FAMILLE][k].GRATUITE_COMMANDE && this.value.GRID_DATAS[fFamille.REF_FAMILLE][k].GRATUITE_COMMANDE != 0) || (!!this.value.GRID_DATAS[fFamille.REF_FAMILLE][k].QUANTITE_CHARGEMENT && this.value.GRID_DATAS[fFamille.REF_FAMILLE][k].QUANTITE_CHARGEMENT != 0) || (!!this.value.GRID_DATAS[fFamille.REF_FAMILLE][k].QUANTITE_GRATUIT && this.value.GRID_DATAS[fFamille.REF_FAMILLE][k].QUANTITE_GRATUIT)) {
                        touchedArticles.push(k);
                    }
                });
                return touchedArticles.lastIndexOf(article.AR_Ref) > -1;
            });
        })
      }
      this.filteredRows = filteredFamilles;
    }

    private _formatBonCommande(_bonCommande: any) {
        const familles = JSON.parse(JSON.stringify((_bonCommande.FAMILLES as any[]).sort((a, b) => ORDER_FAMILLES_IDS.lastIndexOf(a.ID) - ORDER_FAMILLES_IDS.lastIndexOf(b.ID))));
        familles.forEach((famille, index, famillesArr) => {
          var famille_articles = [];
          if (famille.ID == FAMILLE_CDF_VIN_ROUGE_ID || famille.ID == FAMILLE_CDF_SANGRIA_ROUGE_ID) {
            famille_articles = (famille.ARTICLES as any[]).sort((a,b) => a.ID - b.ID);
          } else {
            famille_articles = (famille.ARTICLES as any[]).sort((a,b) => a.AR_Design.localeCompare(b.AR_Design));
          }

          famille_articles.forEach((article) => {
            if (!!this.value.GRID_DATAS && !!this.value.GRID_DATAS[famille.REF_FAMILLE] && !!this.value.GRID_DATAS[famille.REF_FAMILLE][article.AR_Ref] && !!this.value.GRID_DATAS[famille.REF_FAMILLE][article.AR_Ref].MOTIF_MODIFICATION) {
                const motifModification = this.typesModification.find(t => t.ID == this.value.GRID_DATAS[famille.REF_FAMILLE][article.AR_Ref].MOTIF_MODIFICATION);
                this.value.GRID_DATAS[famille.REF_FAMILLE][article.AR_Ref].MOTIF_MODIFICATION = motifModification;
            }

            var qteCommande = 0;
            var qteGratuit = 0;
            var ligne_commande = _bonCommande.LIGNES.find(l => l.FAMILLE_ID == famille.ID && l.AR_Ref == article.AR_Ref);
            if (!!ligne_commande) {
              qteCommande = ligne_commande.DL_QteBC;
              _bonCommande.REMISES.forEach((remise) => {
                if (remise.ENABLED == 1 && remise.REMISE_LIGNES !== undefined && (remise.TYPE_REMISE_ID == Enum_TypeRemise.GRATUITE_ARTICLE || remise.TYPE_REMISE_ID == Enum_TypeRemise.REMISE_TRANSPORT_GRATUITE || remise.TYPE_REMISE_ID == Enum_TypeRemise.REMISE_LIBRE)) {
                  remise.REMISE_LIGNES.filter(l => l.AR_Ref == article.AR_Ref && (l.ALIAS_ID == _bonCommande.ALIAS_ID || _bonCommande.PARENT_BON_COMMANDE_ID == 0)).forEach((ligneArticle) => {
                    qteGratuit += ligneArticle.DL_Qte;
                  });
                }
              });
            }
            this.value.GRID_DATAS[famille.REF_FAMILLE][article.AR_Ref].QUANTITE_COMMANDE = qteCommande;
            this.value.GRID_DATAS[famille.REF_FAMILLE][article.AR_Ref].GRATUITE_COMMANDE = qteGratuit;

          });

          famillesArr[index].ARTICLES = famille_articles;
        });
        _bonCommande.FAMILLES = familles;
        const dateCreation = new Date(_bonCommande.DATE_CREATION);
        _bonCommande.DATE_CREATION = dateCreation.getDate().toString().padStart(2, '0') + "/" + (dateCreation.getMonth() + 1).toString().padStart(2, '0') + "/" + dateCreation.getFullYear();
        this.bonCommande = _bonCommande;
    }
}